import React from 'react';
import './main.css';
import Sidebar from "../nav/sidebar";
import About from "./about";
import Projects from "./projects";
import Skills from "./skills";
import Contact from "./contact";
import { Route } from 'react-router-dom';

const Main = () => {
  return (
    <div className="main">
      <Route path="/" component={Sidebar}/>
      <Route exact path="/" component={About}/>
      <Route path="/projects" component={Projects}/>
      <Route path="/skills" component={Skills}/>
      <Route path="/contact" component={Contact}/>
    </div>
  );
};

export default Main;



// WEBPACK FOOTER //
// ./src/pages/main.jsx